var map = {
	"./en.json": [
		"L4SG",
		2
	],
	"./no.json": [
		"IRZN",
		1
	],
	"./se.json": [
		"+thp",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "knR7";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./lang lazy ^\.\/.*\.json$
// module id = knR7
// module chunks = 4